import React from "react";

export const UploadIconSvg = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#000"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* File outline */}
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    {/* File fold */}
    <polyline points="14 2 14 8 20 8" />

    {/* Upload arrow */}
    <path d="M12 17V10" />
    <polyline points="9 13 12 10 15 13" />
  </svg>
);
